import { FC } from 'react';
import { Outlet } from 'react-router-dom';

import { useAuthContext } from '@/context/AuthContext';
import SalesAccessRestricted from './SalesAccessRestricted/SalesAccessRestricted';

const SalesAccessRoute: FC = () => {
  const { userInfo } = useAuthContext();

  if (!userInfo?.hasCommercialAccess) {
    return <SalesAccessRestricted />;
  }

  return <Outlet />;
};

export default SalesAccessRoute;
